import type { ReactNode } from 'react';
import { Header, type EyebrowTone } from './_shared';

export type QuoteSlideProps = {
  eyebrow: ReactNode;
  eyebrowTone?: EyebrowTone;
  /** Title above the quote (optional — many quote slides only show the quote + attribution). */
  title?: ReactNode;
  quote: ReactNode;
  author: string;
  role?: string;
  /** Accent color for the quote's left border. Default 'blue'. */
  accent?: EyebrowTone;
};

export function QuoteSlide({
  eyebrow,
  eyebrowTone,
  title,
  quote,
  author,
  role,
  accent = 'blue',
}: QuoteSlideProps) {
  const quoteClass = `sn-quote${accent === 'teal' ? ' sn-quote--teal' : ''}`;
  return (
    <div className="slide-body">
      <Header eyebrow={eyebrow} eyebrowTone={eyebrowTone} title={title} />
      <div className="sn-work">
        <blockquote className={quoteClass}>{quote}</blockquote>
        <div className="sn-quote-attribution">
          — <strong>{author}</strong>
          {role ? ` · ${role}` : null}
        </div>
      </div>
    </div>
  );
}
